import { call, put, takeEvery } from "redux-saga/effects"
import {
  DELETE_MATERIAL,
  GET_MATERIAL,
  SAVE_MASSIVE_CHARGE,
  SAVE_MATERIAL,
  UPDATE_MATERIAL,
} from "./actionTypes"
import {
  getMaterialListFail,
  getMaterialListSuccess,
  saveMaterialFail,
  saveMaterialSuccess,
  updateMaterialsFail,
  updateMaterialSuccess,
  deleteMaterialFail,
  deleteMaterialSuccess,
  saveMassiveChargeFail,
  saveMassiveChargeSuccess,
} from "./actions"
import service from "../../api/material.service"
function* fetchGetMaterialList({ payload: filter }) {
  try {
    const response = yield call(service.getMaterialListService, filter.filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(getMaterialListFail(error))
    } else {
      yield put(getMaterialListSuccess(response))
    }
  } catch (error) {
    yield put(getMaterialListFail(error))
  }
}

function* fetchSaveMaterial({ payload: filter }) {
  try {
    const response = yield call(service.saveMaterial, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(saveMaterialFail(error))
    } else {
      yield put(saveMaterialSuccess(response))
    }
  } catch (error) {
    yield put(saveMaterialFail(error))
  }
}
function* fetchUpdateMaterial({ payload: filter }) {
  try {
    const response = yield call(service.updateMaterial, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(updateMaterialsFail(error))
    } else {
      yield put(updateMaterialSuccess(response))
    }
  } catch (error) {
    yield put(updateMaterialsFail(error))
  }
}
function* fetchDeleteMaterial({ payload: filter }) {
  try {
    const response = yield call(service.deleteMaterial, filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(deleteMaterialFail(error))
    } else {
      yield put(deleteMaterialSuccess(response))
    }
  } catch (error) {
    yield put(deleteMaterialFail(error))
  }
}
function* fetchSaveMassiveCharge({ payload: lsMaterial }) {
  try {
    const response = yield call(service.saveMassiveCharge, lsMaterial)
    const error = response?.response?.data?.error
    if (error) {
      yield put(saveMassiveChargeFail(error))
    } else {
      yield put(saveMassiveChargeSuccess(response))
    }
  } catch (error) {
    yield put(saveMassiveChargeFail(error))
  }
}

function* materialSupplierSaga() {
  yield takeEvery(GET_MATERIAL, fetchGetMaterialList)
  yield takeEvery(UPDATE_MATERIAL, fetchUpdateMaterial)
  yield takeEvery(DELETE_MATERIAL, fetchDeleteMaterial)
  yield takeEvery(SAVE_MATERIAL, fetchSaveMaterial)
  yield takeEvery(SAVE_MASSIVE_CHARGE, fetchSaveMassiveCharge)
}

export default materialSupplierSaga
